export const twosteau = {
  data: function () {
    return {
      persistedReservation: '',
      inProgress: false,
      host: 'https://k8s.hacksy-do.com/twosteau'
      // host: 'http://localhost:8080'
    }
  },
  methods: {
    requestReservation: function (reservation, idToken) {
      console.log('idToken: ' + idToken)
      var v = this
      var host = v.host
      var path = '/reservations'

      $.ajax({
        url: host + path,
        type: 'POST',
        data: JSON.stringify(reservation),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        beforeSend: function (xhr) {
          // if (typeof (idToken) !== 'undefined') {
          //   xhr.setRequestHeader('Authorization', 'Bearer ' + idToken)
          // }
          v.inProgress = true
          v.$emit('requestInProgress', v.inProgress)
        },
        error: function (jqhxr, textStatus, errorThrown) {
          v.$emit('requestFailed', jqhxr.status)
        },
        success: function (data) {
          v.persistedReservation = data
          v.$emit('requestReceived', v.persistedReservation)
        },
        complete: function () {
          v.inProgress = false
          v.$emit('requestInProgress', v.inProgress)
        }
      })
    },
    getReservations: function (idToken) {
      var v = this
      var host = v.host
      var path = '/reservations'

      $.ajax({
        url: host + path,
        type: 'GET',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        beforeSend: function (xhr) {
          if (typeof (idToken) !== 'undefined') {
            xhr.setRequestHeader('Authorization', 'Bearer ' + idToken)
          }
          v.$emit('requestInProgress', true)
        },
        success: function (data) {
          v.$emit('requestReceived', data)
        },
        complete: function () {
          v.inProgress = false
          v.$emit('requestInProgress', false)
        }
      })
    },
    getSavedContacts: function (idToken) {
      var v = this
      var host = v.host
      var path = '/contacts'

      $.ajax({
        url: host + path,
        type: 'GET',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        beforeSend: function (xhr) {
          if (typeof (idToken) !== 'undefined') {
            xhr.setRequestHeader('Authorization', 'Bearer ' + idToken)
          }
          v.$emit('requestInProgress', true)
        },
        success: function (data) {
          console.log(data)
          v.$emit('contactsReceived', data)
        },
        complete: function () {
          v.inProgress = false
          v.$emit('requestInProgress', false)
        }
      })
    },
    getAccountCodes: function (idToken) {
      var v = this
      var host = v.host
      var path = '/accountCodes'

      $.ajax({
        url: host + path,
        type: 'GET',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        beforeSend: function (xhr) {
          // if (typeof (idToken) !== 'undefined') {
          //   xhr.setRequestHeader('Authorization', 'Bearer ' + idToken)
          // }
          v.$emit('requestInProgress', true)
        },
        success: function (data) {
          console.log(data)
          v.$emit('accountCodesReceived', data)
        },
        complete: function () {
          v.inProgress = false
          v.$emit('requestInProgress', false)
        }
      })
    },
    postAccountCode: function (accountCode, idToken) {
      var v = this
      var host = v.host
      var path = '/accountCodes'

      $.ajax({
        url: host + path,
        type: 'POST',
        data: JSON.stringify(accountCode),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        beforeSend: function (xhr) {
          // if (typeof (idToken) !== 'undefined') {
          //   xhr.setRequestHeader('Authorization', 'Bearer ' + idToken)
          // }
          v.inProgress = true
          v.$emit('requestInProgress', v.inProgress)
        },
        success: function (data) {
          v.persistedCode = data
          v.$emit('accountCodePosted', v.persistedCode)
        },
        complete: function () {
          v.inProgress = false
          v.$emit('requestInProgress', v.inProgress)
        }
      })
    },
    putAccountCode: function (accountCode, idToken) {
      var v = this
      var host = v.host
      var path = '/accountCode/' + accountCode.id

      $.ajax({
        url: host + path,
        type: 'PUT',
        data: JSON.stringify(accountCode),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        beforeSend: function (xhr) {
          // if (typeof (idToken) !== 'undefined') {
          //   xhr.setRequestHeader('Authorization', 'Bearer ' + idToken)
          // }
          v.inProgress = true
          v.$emit('requestInProgress', v.inProgress)
        },
        success: function (data) {
          v.persistedCode = data
          v.$emit('accountCodePut', v.persistedCode)
        },
        complete: function () {
          v.inProgress = false
          v.$emit('requestInProgress', v.inProgress)
        }
      })
    },
    validateAccountCode: function (accountCode) {
      var v = this
      var host = v.host
      var path = '/validateAccountCode/' + accountCode.id

      $.ajax({
        url: host + path,
        type: 'GET',
        data: JSON.stringify(accountCode),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        beforeSend: function (xhr) {
          v.inProgress = true
          v.$emit('requestInProgress', v.inProgress)
        },
        success: function (data) {
          v.accountCodeValidation = data
          v.$emit('accountCodeValidation', v.accountCodeValidation)
        },
        complete: function () {
          v.inProgress = false
          v.$emit('requestInProgress', v.inProgress)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/clients/twosteau.js